
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ManageBusinessInfoService {

  constructor(private api: ApiService) { }

  getClient(data: any): Observable<any> {
    return this.api.post(environment.getClient, data);
  }

  updateClient(data: any): Observable<any> {
    return this.api.post(environment.updateClient, data);
  }
}
